import type { HTMLAttributes } from "react";

interface LoaderProps extends HTMLAttributes<HTMLSpanElement> {
  size?: number;
  "aria-label"?: string;
}

export function Loader({
  size = 16,
  className = "",
  "aria-label": ariaLabel,
  style,
  ...rest
}: LoaderProps) {
  const accessibilityProps = ariaLabel
    ? { role: "status", "aria-label": ariaLabel }
    : { "aria-hidden": true };
  const mergedStyle = { width: size, height: size, ...style };

  return (
    <span
      {...accessibilityProps}
      {...rest}
      className={`inline-block animate-spin rounded-full border-2 border-current border-t-transparent ${className}`}
      style={mergedStyle}
    />
  );
}
